<template>
  <layout activeLabel="个人资料">
    <div class="card">
      <el-form class="form-card" ref="form" :model="form" label-width="60px">
        <el-form-item label="昵称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="saveBtn" @click="saveInfo('form')">保存</el-button>
        </el-form-item>
      </el-form>
      <div class="right">
        <el-upload
            class="avatar-uploader"
            :multiple="false"
            :action="$uploadFileUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
        >
          <div class="image-area" >
            <div v-if="form.avatar">
              <img :src="$imgUrl + form.avatar" class="avatar" />
              <span>修改头像</span>
            </div >
            <div v-else>
              <img :src="require('../../assets/image/photo.jpg')" class="avatar" />
              <span>修改头像</span>
            </div>
          </div>
          <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
        </el-upload>
        <div class="score">
          <span v-if="score == 0">{{ "暂无评分" }}</span>
          <el-rate
              v-if="score != 0"
              v-model="score"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}"
          />
        </div>
        <div class="title" v-if="score != 0">历史评分</div>
      </div>
    </div>
  </layout>
</template>

<script>
import { saveUserInfo, userScoreApi } from "../../http/api/user.js";
import layout from "./index.vue";
export default {
  name: "leaveMessage",
  components: {
    layout,
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        avatar: "",
      },
      score: 0,
    };
  },
  created() {
    this.form.name = this.$store.state.name;
    this.form.phone = this.$store.state.account;
    this.form.avatar = this.$store.state.avatar;
    // this.getScore();
  },
  methods: {
    //评分有问题 ，暂时去掉
    // getScore(){
    // 	userScoreApi().then(res => {
    // 		this.score = res
    // 	})
    // },
    saveInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveUserInfo({
            heading: this.form.avatar,
            name: this.form.name,
            phone: this.form.phone,
          }).then((res) => {
            this.$message({
              message: "保存信息成功。",
              type: "success",
              duration: 2000,
            });
            window.localStorage.setItem("name", this.form.name);
            window.localStorage.setItem("account", this.form.phone);
            window.localStorage.setItem("avatar", this.form.avatar);
          });
        }
      });
    },
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.form.avatar = res.fileName;
      } else {
        this.$message({
          type: "warning",
          message: "图片文件过大",
        });
      }
      // this.ruleForm.pictureUrl = file.fileName;
    },
  },
};
</script>
<style lang="less" scoped>
.card {
  padding-right: 1rem;
  padding-top: 0.48rem;
  box-sizing: border-box;
  display: flex;

  .form-card {
    padding: 0 1rem 0.7rem;
    flex: 1;

    .saveBtn {
      width: 1.38rem;
      background: #5c5c5c;
      border-radius: 0.06rem;
      opacity: 1;
      margin-top: 0.4rem;
      font-size: 0.14rem;
      color: #fff;
      padding: 0;
      line-height: 0.2rem;
      padding: 0.12rem 0;
    }
  }

  /deep/ .el-form-item__label {
    text-align: left;
    font-size: 0.14rem;
    color: #929292;
  }

  /deep/ .el-input__inner {
    background: #f5f5f5;
    font-size: 0.13rem;
    border: unset;
    color: #000;
  }

  .right {
    // .img-box {
    // 	width: 1.16rem;
    // 	height: 1.16rem;
    // }

    .score {
      font-size: 15px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.15rem;
        height: 0.15rem;
        margin-right: 0.06rem;
      }

      .num {
        padding-left: 0.1rem;
        color: #ff7e36;
        font-size: 0.13rem;
      }
    }

    .title {
      color: #6c6c6c;
      font-size: 0.12rem;
      margin-top: 0.12rem;
      text-align: center;
    }
  }
}

.avatar-uploader .el-upload {
  height: 128px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: @vue-border-radius-circle;
  box-sizing: border-box;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
}

.image-area {
  width: 128px;
  height: 128px;
  position: relative;
  border-radius: @vue-border-radius-circle;
  overflow: hidden;
  .avatar {
    width: 128px;
    height: 128px;
    border-radius: @vue-border-radius-circle;
    overflow: hidden;}

  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  span {
    width: 100%;
    height: 30px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: @vue-font-size-sm - 2;
    color: @vue-text-color-inverse;
    background: @vue-bg-color-mask;
  }
}
</style>
